import axios from "axios";
import { getCookie } from "../getcookie.js";
const apiUrl = process.env.REACT_APP_API_URL;
const adminApiUrl = process.env.REACT_APP_ADMIN_API_URL;

const header={
   'Content-Type': 'application/json; charset=UTF-8',
   "Accept": "application/json",
   "Access-Control-Allow-Origin": "*", // Required for CORS support to work
   "Authorization": getCookie("mawalog")
 }

 export const createDockSetupApi = async (data) => {  
   try {
     const response = await axios.post(
       apiUrl+`dockmaster`,data, { headers: header }).then((response) => {
         return response;
       }).catch((error) => {
         console.log('error...',error.response)
         return error.response;          
       });
       return response; 
   } catch (err) {
     console.error("Error fetching category:", err);
   } finally {
   }
 };

 export const updateDockSetupApi = async (id,data) => {  
   try {
     const response = await axios.put(
       apiUrl+`dockmaster/`+id,data, { headers: header }).then((response) => {
         return response;
       }).catch((error) => {
         console.log('error...',error.response)
         return error.response;          
       });
       return response; 
   } catch (err) {
     console.error("Error fetching category:", err);
   } finally {
   }
 };


  export const getUserApi = async (term) => { 
   try {
     const response = await axios.get(
      adminApiUrl+`employee/autocomplete?term=`+term,
       {
         headers: header,
       }
     );
 return response;
   } catch (err) {
     console.error("Error fetching category:", err);
   } finally {
   }
 };
 
 export const createVehicleTypeApi = async (data) => {  
   try {
     const response = await axios.post(
       apiUrl+`vehicletype`,data, { headers: header }).then((response) => {
         return response;
       }).catch((error) => {
         console.log('error...',error.response)
         return error.response;          
       });
       return response; 
   } catch (err) {
     console.error("Error fetching category:", err);
   } finally {
   }
 };

 export const updateVehicleTypApi = async (id,data) => {  
   try {
     const response = await axios.put(
       apiUrl+`vehicletype/`+id,data, { headers: header }).then((response) => {
         return response;
       }).catch((error) => {
         console.log('error...',error.response)
         return error.response;          
       });
       return response; 
   } catch (err) {
     console.error("Error fetching category:", err);
   } finally {
   }
 };
 
 export const getVehicleTypeApi = async (id) => { 
   try {
     const response = await axios.get(
       apiUrl+`vehicletype/get/`+id,
       {
         headers: header,
       }
     );
 return response;
   } catch (err) {
     console.error("Error fetching category:", err);
   } finally {
   }
 }; 

  export const getDockMasterListApi = async (params) => { 
   try {
     const response = await axios.get(
       apiUrl+`dockmaster?`+params,
       {
         headers: header,
       }
     );
 return response;
   } catch (err) {
     console.error("Error fetching category:", err);
   } finally {
   }
 }; 

 export const getVehicleTypeListApi = async (params) => { 
   try {
     const response = await axios.get(
       apiUrl+`vehicletype?`+params,
       {
         headers: header,
       }
     );
 return response;
   } catch (err) {
     console.error("Error fetching category:", err);
   } finally {
   }
 }; 
 
 
 export const getDockGateApi = async (id) => { 
   try {
     const response = await axios.get(
       apiUrl+`dockmaster/get/`+id,
       {
         headers: header,
       }
     );
 return response;
   } catch (err) {
     console.error("Error fetching category:", err);
   } finally {
   }
 }; 

 export const getDeleteApi = async (deleteUrl) => {
 
   try {
     const response = await axios.delete(
       apiUrl+deleteUrl,
       {
         headers: header,
       }
     );
 return response;
   } catch (err) {
     
     console.error("Error fetching category:", err);
     return err.response;
   } finally {
   }
 };

  export const bulkDeleteApi = async (deleteUrl,ids) => {
 
   try {
     const response = await axios.delete(
       apiUrl+deleteUrl,
       {
         headers: header,
         data:{"id":ids}
       },
     );
 return response;
   } catch (err) {
     
     console.error("Error fetching category:", err);
     return err.response;
   } finally {
   }
 };